module.exports = __webpack_public_path__ + "img/thank-you.d3f69393.gif";